import { AsyncPipe } from '@angular/common';
import { Component, inject, input, model, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IAgregarPagoComponent } from '@core/interfaces/components/agregarPago.component.interface';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { TipoPagoService } from '@shared/services/tipo-pago.service';
import { UiSelect } from '@shared/components/ui';
import { map } from 'rxjs';

@Component({
  selector: 'app-agregar-pago',
  imports: [UiSelect, FormsModule, AsyncPipe],
  templateUrl: './agregar-pago.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agregar-pago.css',
})
export class AgregarPago implements OnInit {
  // servicios
  private tipoPagoService = inject(TipoPagoService);
  // datos
  optionsTipoPago$ = this.tipoPagoService.listTiposPago.pipe(
    map((tiposPago) => tiposPago.map((tipoPago) => ({ label: tipoPago.nombre, value: tipoPago })))
  );
  monto_pago_sugerido = input<number>();
  selected_tipo_pago?: ITipoPagoData;
  monto_pago = model<number>(0);

  // métodos
  agregar = output<IAgregarPagoComponent>();
  agregarPago() {
    this.agregar.emit({
      monto: this.monto_pago(),
      tipo_pago: this.selected_tipo_pago,
    });
    this.monto_pago.set(0);
  }

  ngOnInit(): void {
    this.monto_pago.set(this.monto_pago_sugerido() || 0);
  }
}
